import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import NewInput from 'app/components/NewInput';
import Dropdown from 'app/components/Dropdown';
import PageLoader from 'app/components/PageLoader';
import Button from 'app/components/button';
import Toggle from 'react-toggle';
import NewAttachment from 'app/components/NewAttachment';
import TextArea from 'app/components/Textarea';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import useCreateGame from './useCreateGame';
import { commonMaxDate, commonMinDate } from 'app/utils/Parsers';

const CreateGame = () => {
  const {
    gameId,
    handleChange,
    values,
    error,
    handleCreateGame,
    pageLoading,
    uploadMediaHandler,
    setChange,
    navigate,
    handleResetScores,
    availableGames,
    availableGamesFetchFailed,
    handleSelectGame,
  } = useCreateGame();

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={`${gameId ? ' Edit Game ' : 'Create Game'}`}
          goTo={APP_CONSTANTS.GAME_MANAGEMENT}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <NewInput
              label='Game Title*'
              id='title'
              type='text'
              placeholder='Game Title'
              name='title'
              value={values?.title}
              onChange={handleChange}
              errorText={error?.title}
            />
          </div>
          <div className='wd-50'>
            {gameId ? (
              <NewInput
                label='Slug'
                id='slug'
                type='text'
                name='slug'
                value={values?.slug}
                disabled
                readOnly
              />
            ) : availableGamesFetchFailed ? (
              <NewInput
                label='Slug*'
                id='slug'
                type='text'
                placeholder='Slug'
                name='slug'
                value={values?.slug}
                onChange={handleChange}
                errorText={error?.slug}
              />
            ) : (
              <Dropdown
                id='slug'
                label='Game (Slug)*'
                name='slug'
                options={availableGames.map((g) => ({
                  label: g.title,
                  value: g.slug,
                }))}
                placeholder='Select Game'
                value={values?.slug}
                handleChange={(e) => handleSelectGame(e.target.value)}
                errorText={error?.slug}
              />
            )}
          </div>
          {/* Thumbnail field hidden for now (08-Jul-26, user decision) — Sort
              Order takes its place in the layout; un-comment to restore.
          <div className='wd-50'>
            <label> Thumbnail </label>
            <NewAttachment
              value={values?.thumbnail}
              id='thumbnail'
              onFileSelected={uploadMediaHandler}
              fileType='image'
              label='Choose File'
              className='feed_attachment'
              alt='thumbnail'
              errorText={error?.thumbnail}
            />
          </div>
          */}
          <div className='wd-50'>
            <NewInput
              label='Campaign Start Date'
              id='startDate'
              placeholder='DD-MM-YYYY'
              name='startDate'
              format='DD-MM-YYYY'
              type={'date'}
              max={commonMaxDate()}
              value={values?.startDate}
              onChange={handleChange}
              errorText={error?.startDate}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Campaign End Date'
              name='endDate'
              id='endDate'
              placeholder={'End Date'}
              min={values.startDate ? values.startDate : commonMinDate()}
              max={commonMaxDate()}
              value={values?.endDate}
              type={'date'}
              onChange={handleChange}
              errorText={error?.endDate}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Sort Order'
              id='sortOrder'
              type='number'
              placeholder='Sort Order'
              name='sortOrder'
              value={values?.sortOrder}
              onChange={handleChange}
              errorText={error?.sortOrder}
            />
          </div>
          <div className='wd-50 d-flex flex-column justify-content-center'>
            <label className='me-2 d-inline-block tooltip-on-hover'>
              Status*
            </label>
            <label className='d-inline-block mt-2'>
              <div className='d-inline-flex align-items-center'>
                <div className='d-inline-flex text-danger'>OFF</div>
                <div className='d-inline-flex mx-2'>
                  <Toggle
                    checked={values.isEnabled}
                    icons={false}
                    onChange={() => setChange('isEnabled', !values.isEnabled)}
                  />
                </div>
                <div className='d-inline-flex text-green'>ON</div>
              </div>
            </label>
          </div>
          {/* Config (JSON) field hidden for now (09-Jul-26, user decision) —
              un-comment to restore.
          <div className='wd-100'>
            <TextArea
              label='Config (JSON, optional)'
              id='config'
              type='text'
              placeholder='{ "livesRegenSeconds": 30 }'
              name='config'
              value={values?.config}
              onChange={handleChange}
              errorText={error?.config}
            />
          </div>
          */}
        </div>
        <div className='d-flex justify-content-start'>
          <Button
            className='mt1'
            onClick={handleCreateGame}
            variant='Save'
            name='Submit'
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={() => navigate(-1)}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
          {/* View Leaderboard button hidden for now (09-Jul-26, user decision)
              — redundant with the row-level View Leaderboard action already
              on the Games listing page; un-comment to restore.
          {gameId && (
            <Button
              className='mt1 ms-2'
              onClick={() =>
                navigate(`/games/leaderboard/:${gameId}`, {
                  state: { id: gameId, title: values.title },
                })
              }
              variant='View Leaderboard'
              name='View Leaderboard'
              isDisabled={pageLoading ? true : false}
            />
          )}
          */}
          {gameId && (
            <Button
              className='mt1 ms-2'
              onClick={handleResetScores}
              variant='Reset Scores'
              name='Reset Scores'
              isDisabled={pageLoading ? true : false}
            />
          )}
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateGame;
